import React from 'react';
import './EmptyState.css';
import emptyStateProjects from '../../assets/empystates/empty-state-projects.png';
import emptyStateConversations from '../../assets/empystates/empty-state-conversations.png';
import emptyStateArtifacts from '../../assets/empystates/empty-state-artifacts.png';

export type EmptyStateType = 'projects' | 'artifacts' | 'conversations' | 'conversationsAll' | 'files';

interface EmptyStateProps {
  type: EmptyStateType;
  onButtonClick: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ type, onButtonClick }) => {
  const getImageSrc = () => {
    switch (type) {
      case 'projects':
        return emptyStateProjects;
      case 'artifacts':
        return emptyStateArtifacts;
      case 'conversations':
      case 'conversationsAll':
        return emptyStateConversations;
      case 'files':
        return emptyStateArtifacts;
      default:
        return emptyStateProjects;
    }
  };

  const getText = () => {
    switch (type) {
      case 'projects':
        return 'You haven\'t created any projects yet';
      case 'artifacts':
        return 'You don\'t have any Artifacts\nassociated to this project yet';
      case 'conversations':
        return 'You don\'t have any conversations\nassociated to this project yet';
      case 'conversationsAll':
        return 'You don\'t have any conversations yet';
      case 'files':
        return 'You don\'t have any files\nassociated to this project yet';
      default:
        return '';
    }
  };

  const getButtonText = () => {
    switch (type) {
      case 'projects':
        return 'Create New Project';
      case 'artifacts':
        return 'Create an Artifact';
      case 'conversations':
      case 'conversationsAll':
        return 'Start a New Conversation';
      case 'files':
        return 'Upload a File';
      default:
        return '';
    }
  };

  return (
    <div className="empty-state-container">
      <img
        src={getImageSrc()}
        alt="Empty state"
        className="empty-state-image"
      />
      <p className="empty-state-text">{getText()}</p>
      <button
        className="empty-state-button"
        onClick={onButtonClick}
      >
        {getButtonText()}
      </button>
    </div>
  );
};

export default EmptyState;
